module.exports = __webpack_public_path__ + "static/media/icon-thomson.8417a6d4.svg";